import { api } from ".";
import qs from "query-string";
import { Translate } from "models";

const url = "/translates";

const translateAPI = api.injectEndpoints({
	endpoints: (build) => ({
		getTranslates: build.query<Translate[], Record<string, any> | undefined>({
			query: (query) => {
				if (query) {
					return `${url}?${qs.stringify(query)}`;
				}
				return url;
			},
			// providesTags: (result) => providesList(result, "Translates"),
		}),
	}),
});
export const { useLazyGetTranslatesQuery, useGetTranslatesQuery } = translateAPI;
